<template>
  <div v-if="show">
    <!-- Modal -->
    <div class="modal show fade" style="display: block">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">

          <!-- Header -->
          <div class="modal-header">
            <h5 class="modal-title">Verify IBAN</h5>
            <button type="button" class="close" @click="close">
              <span>&times;</span>
            </button>
          </div>

          <!-- Body -->
          <div class="modal-body">
            <div class="alert alert-danger mt-1" role="alert"   v-if="error && !loading">
              <div class="alert-body">
                <p class=""><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info mr-50 align-middle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> {{ error }}</p>
              </div>
            </div>
            <!-- Account Title -->
            <div v-if="response && !loading" class="form-group">
              <label>Account Title</label>
              <input
                  type="text"
                  class="form-control"
                  v-model="customAccountTitle"
                  :placeholder="response.accountTitle || 'Account Title'"
              />
            </div>
            <!-- IBAN -->
            <div class="form-group">
              <label>IBAN</label>
              <input
                  type="text"
                  class="form-control"
                  v-model="localIban"
                  disabled
              />
            </div>

<!--            <div class="custom-control custom-switch mb-1" v-if="error">-->
<!--              <input-->
<!--                  type="checkbox"-->
<!--                  class="custom-control-input"-->
<!--                  id="saveWithCustomAccountTitle"-->
<!--                  v-model="saveWithCustomAccountTitle"-->
<!--              />-->
<!--              <label class="custom-control-label"   for="saveWithCustomAccountTitle">     Save with custom account title</label>-->
<!--            </div>-->

            <!-- Loader -->
            <div v-if="loading" class="text-center my-2">
              <span class="spinner-border spinner-border-sm"></span>
            </div>

            <!-- Response -->
            <div v-if="response && !loading" class="mt-2">
              <hr />
              <p><strong>Bank Account Title:</strong> {{ response.accountTitle }}</p>
              <p><strong>Bank Name:</strong> {{ response.bankName }}</p>
              <p><strong>Bank Code:</strong> {{ response.bankCode }}</p>
              <p><strong>Swift Code:</strong> {{ response.swiftCode }}</p>
              <p><strong>IBAN:</strong> {{ response.iban }}</p>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-secondary"
                :disabled="loading"
                @click="close"
            >
              Cancel
            </button>

            <button
                v-if="!response"
                type="button"
                class="btn btn-primary"
                :disabled="loading"
                @click="onVerify"
            >
              Verify
            </button>

            <button
                v-if="response && response.status === 2"
                type="button"
                class="btn btn-success"
                :disabled="loading"
                @click="onSave"
            >
              Save
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- Backdrop -->
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  name: "VerifyIbanModal",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    iban: {
      type: String,
      default: ""
    },
    response: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    }
  },
  mounted() {

  },
  data() {
    return {
      localIban: "",
      saveWithCustomAccountTitle: false,
      customAccountTitle: ""
    };
  },

  watch: {
    iban: {
      immediate: true,
      handler(val) {
        this.localIban = val;
      }
    },
    show(val) {
      if (val) {
        // reset state when modal opens
        this.saveWithCustomAccountTitle = false;
        this.customAccountTitle = "";
        this.$emit('clear-error')
      }
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },

    onVerify() {
      this.$emit("verify", {
        iban: this.localIban,
        saveWithCustomAccountTitle: this.saveWithCustomAccountTitle
      });
    },

    onSave() {
      this.$emit("save", {
        iban: this.localIban,
        saveWithCustomAccountTitle: this.saveWithCustomAccountTitle,
        accountTitle: this.customAccountTitle,
        fromDetails:false
      });
    }
  }
};
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.2);
}
</style>
